const CSS_ZOOM_MAX = 3

export function pinchDistance (touches) {
  if (!touches || touches.length < 2) {
    return 0
  }
  const dx = touches[0].clientX - touches[1].clientX
  const dy = touches[0].clientY - touches[1].clientY
  return Math.sqrt(dx * dx + dy * dy)
}

export function clampZoom (value, min, max) {
  return Math.min(max, Math.max(min, value))
}

export function readZoomCapability (track) {
  if (!track || !track.getCapabilities) {
    return { supported: false, min: 1, max: CSS_ZOOM_MAX, step: 0.1 }
  }
  try {
    const caps = track.getCapabilities()
    const zoom = caps && caps.zoom
    if (zoom && typeof zoom.max === 'number' && zoom.max > (zoom.min || 1)) {
      return {
        supported: true,
        min: typeof zoom.min === 'number' ? zoom.min : 1,
        max: zoom.max,
        step: typeof zoom.step === 'number' && zoom.step > 0 ? zoom.step : 0.1
      }
    }
  } catch (err) {}
  return { supported: false, min: 1, max: CSS_ZOOM_MAX, step: 0.1 }
}

export function applyHardwareZoom (track, zoom) {
  if (!track || !track.applyConstraints) {
    return Promise.resolve(false)
  }
  return track.applyConstraints({
    advanced: [{ zoom }]
  }).then(() => true).catch(() => false)
}

export function drawZoomedVideoFrame (video, canvas, zoom, hardwareZoom) {
  const width = video.videoWidth
  const height = video.videoHeight
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  if (hardwareZoom || zoom <= 1) {
    ctx.drawImage(video, 0, 0)
    return
  }
  const srcW = width / zoom
  const srcH = height / zoom
  const sx = (width - srcW) / 2
  const sy = (height - srcH) / 2
  ctx.drawImage(video, sx, sy, srcW, srcH, 0, 0, width, height)
}
